{
  "unvan": {
    "Ünvanlar": "Unvan Tanımları",
    "Unvan Adı": "Unvan Adı",
    "Sıra": "Sıra",
    "Komisyon Türü": "Komisyon Türü",
    "Durum": "Durum",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "Tümü": "Tümü",
    "Yeni Ekle": "Yeni Ekle",
    "Ekle": "Ekle",
    "Güncelle": "Güncelle",
    "Kaydet": "Kaydet",
    "İptal": "İptal",
    "Sil": "Sil",
    "Filtrele": "Filtrele",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Arama_Placeholder": "Ara...",
    "Yenile": "Yenile",
    "İşlemler": "İşlemler",
    "Data Yenile": "Verileri Yenile",
    "Kapat": "Kapat",
    "Düzeltme": "Düzenle",
    "Ad_Placeholder": "Örn: Müdür, Uzman vb.",
    "Sira_Placeholder": "Örn: 10"
  }
}
